import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const syncDataToCloud = async (userId, data) => {
  try {
    await setDoc(doc(db, 'users', userId), {
      shoppingList: data.shoppingList || [],
      recipeHistory: data.recipeHistory || [],
      customLists: data.customLists || [],
      themeColor: data.themeColor,
      theme: data.theme,
      shoppingMode: data.shoppingMode,
      lastUpdated: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error syncing data:', error);
    throw error;
  }
};

export const loadDataFromCloud = async (userId) => {
  try {
    const docRef = doc(db, 'users', userId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return docSnap.data();
    }
    return null;
  } catch (error) {
    console.error('Error loading data:', error);
    throw error;
  }
}; 